export default "__VITE_ASSET__62bef378__"